import React, { useMemo } from 'react';
import { useQuery } from 'react-query';

import Loading from 'components/atoms/Loading';
import Section from 'components/organisms/Section';
import VideoHome, { VideoType } from 'components/templates/Home/VideoHome';
import i18n from 'i18n';
import { getNewsVideoListService } from 'services/news';
import { DEFAULT_QUERY_OPTION } from 'utils/constants';
import { getImageURL } from 'utils/functions';

export interface VideoListBlocks {
  title: string;
  link: {
    text: string;
    url: string;
    target: string;
  };
}

interface VideoListBlock {
  blocks: VideoListBlocks;
}

const RenderLoading = (loading: boolean, component: React.ReactElement) => {
  if (loading) return <Loading variant="default" isShow />;
  return component;
};

const VideoList: React.FC<VideoListBlock> = ({
  blocks,
}) => {
  const {
    isLoading: newsVideoLoading,
    data: newsVideoData,
  } = useQuery(['GetHomeVideo', i18n.language], () => getNewsVideoListService({ limit: 4 }), {
    ...DEFAULT_QUERY_OPTION,
    refetchOnMount: true,
  });
  const newsVideoList = useMemo(() => {
    if (newsVideoData) {
      return newsVideoData.data.map((val) => ({
        thumbnail: getImageURL(val.thumbnail),
        videoUrl: val.linkType === '5' ? val.urlLink : getImageURL(val.urlLink),
        description: val.title,
        type: val.linkType === '5' ? 'youtube' : ('video' as VideoType),
        isLive: false,
      }));
    }
    return [];
  }, [newsVideoData]);
  return (
    <Section className="p-home_videoList">
      {RenderLoading(
        newsVideoLoading,
        <VideoHome
          title={blocks.title}
          viewMoreText={blocks.link.text}
          href={blocks.link.url}
          target={blocks.link.target}
        // TODO
          videoList={newsVideoList}
        />,
      )}

    </Section>
  );
};

export default VideoList;
